const ContentData = () => {
  const staticData = {
    Facilities: [
      "College View",
      "Infrastructure",
      "Laboratory",
      "Observatory",
      "MI room",
      "Smart Class",
      "Exam Hall",
      "Cafeteria",
      "Gym",
      "Mess",
    ],
    "About Us": [
      "History",
      "About KRISAT",
      "Vision & Mission",
      "Board Members",
      "Governing Council",
      "From Principal Desk",
    ],
    Farming: [
      "Animal Husbandry",
      "Organic Field",
      "Wet Land",
      "Orchard",
      "Garden Land",
      "Dry Land",
      "IFS",
    ],
    Academics: [
      "Courses Offered",
      "Faculty",
      // "Academic Calendar",
      // "Class Timetable",
      "College Library",
      // "Instructional Exam",
    ],
    "Academic Activities": [
      "NSS Programs",
      "Crop Production",
      "Short Tour",
      "Outdoor Visit",
      "Field Classes",
      "All India Study Tour",
    ],
    "Life @ KRISAT": [
      "Hostel",
      "Culturals",
      "Sports Activities",
      // "Grievance",
      // "Infrastructure",
    ],
    Nursery: [
      // "Indoor Planting",
      // "Outdoor Planting",
      // "Crotons",
      // "Flower Plants",
      // "Hanging & Creeper",
      "Climbers",
      "Creepers",
      "Flowers",
      "Fruits",
      "Indoor Plants",
      "Medicinal Plants",
      "Out Door Plants",
      "Shrubs",
      "Trees"
    ],
    // "Rules & Regulations": ["Academic Rules", "College Rules", "Hostel Rules"],
  };

  return { staticData };
};

export default ContentData;
